import { useClusterRestrictionsQuery } from 'hooks/queries/cluster-restrictions/useClusterRestrictionsQuery';

import { useCluster } from '@cast/shared-cluster-context-data-access';

type UseCostReportWorkloadRestrictionsArgs = {
  workloadName: string;
  namespace: string;
  workloadType: string;
};

export const useCostReportWorkloadRestrictions = ({
  workloadName,
  namespace,
  workloadType,
}: UseCostReportWorkloadRestrictionsArgs) => {
  const { cluster } = useCluster();

  const { data, isLoading } = useClusterRestrictionsQuery({
    organizationId: cluster.organizationId!,
    clusterId: cluster.id,
    filterResourceNames: [workloadName],
    filterResourceKinds: [workloadType],
    filterResourceNamespaces: [namespace],
  });

  const restrictions = data?.items ?? [];

  return {
    restrictions,
    isLoading,
    hasRestrictions: restrictions.length > 0,
  };
};
